import { Suspense } from 'react';
import { designs } from '../designs';

const ORIGINAL_LOGO = '/logos/froma-original.png';

// Loading Fallback
function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-sky-900/30">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-orange-200 dark:border-orange-800 border-t-orange-500 rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-slate-400 dark:text-gray-400">Loading...</p>
      </div>
    </div>
  );
}

// Main Landing Page
export default function LandingPage() {
  const DesignComponent = designs[0].component;

  return (
    <Suspense fallback={<LoadingFallback />}>
      <DesignComponent logo={ORIGINAL_LOGO} />
    </Suspense>
  );
}
